module.exports = __webpack_public_path__ + "img/Denmark.af26fb0e.svg";